<template>
  <div class="page">
    <div class="preview-title">{{data.exam.examTitle}}</div>
    <el-form label-width="120px">
      <el-row>
        <el-col>
          <el-form-item
            label="开卷时间"
          >{{ strategyMap['dateFormat'](data.exam.date[0],'yyyy-MM-dd')}} - {{strategyMap['dateFormat'](data.exam.date[1],'yyyy-MM-dd')}}</el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="4">
          <el-form-item label="出卷人">{{data.exam.author.nickname}}</el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="参考时间">{{data.exam.time}}分钟</el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="参考总分">{{data.exam.totalScores}}分</el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="8">
          <el-form-item
            label="开始答题时间"
          >{{strategyMap['dateFormat'](data.startTime,'yyyy-MM-dd hh:mm')}}</el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col :span="8">
          <el-form-item
            label="结束答题时间"
          >{{strategyMap['dateFormat'](data.endTime,'yyyy-MM-dd hh:mm')}}</el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-between">
        <el-col :span="8">
          <el-form-item label="阅卷人">{{data.judgeUser && data.judgeUser.nickname || '等待阅卷中。。'}}</el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item label="得分">
            <span class="score">{{data.totalScores}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex">
        <el-col>
          <el-form-item
            label="评语"
          >{{data.comment}}</el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <div class="preview-title sub">试卷详情</div>
      </el-row>
      <el-row v-for="(item,index) in data.answerRecord" :key="index" class="question-wrap">
        <el-col :span="12" class="col">
          <el-form-item label="Question:"><pre>{{item.question.question}}</pre></el-form-item>
          <el-form-item
            label="Option:"
            v-for="(_item,index) in item.question.options"
            :key="index"
          >{{_item}}</el-form-item>
          <el-form-item label="Answer:">
            <pre>{{item.question.answer}}</pre>
          </el-form-item>
          <el-form-item label="Re. Score:">{{item.question.score || 0}}分</el-form-item>
        </el-col>
        <el-col :span="12">
            <el-form-item label="Your Answer:"><pre>{{item.answer}}</pre></el-form-item>
            <el-form-item label="Got Score:"><span class="score small">{{item.score || 0}}</span></el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
import utils from "@/utils/index";
import { strategyMap } from "@/utils/formatter.js";
export default {
  data() {
    return {
      strategyMap,
      data: {
        exam: {
          author: {},
          date: ["", ""]
        },
        judgeUser: {}
      },
      loading: false
    };
  },
  mounted() {
    utils.ajax.call(
      this,
      "/getRecordDetail",
      { ...this.$route.query },
      (data, err) => {
        if (!err) {
          this.data = data;
        }
      }
    );
  },
  methods: {}
};
</script>

<style scoped lang="less">
.score{
font-size:32px;color:red;font-weight:600
}
.small{
    font-size:18px;
}
.question-wrap{
    padding:5px;
    margin:5px;
    border-bottom:1px solid #eee;
    .col{
        border-right:1px solid #eee;
    }
}
</style>
